<template>
  <div class="content">
    <el-row class="border-1">
      <el-form
        :inline="true"
        label-position="right"
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item class="one" label="项目名称">
              <el-input v-model="form.projectname" required></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="two" label="业主名称">
              <el-input v-model="form.username"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="项目编码">
              <el-input style="width: 100%" v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="time" label="评审时间">
                <el-date-picker
                  v-model="form.time"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="专家品目">
              <el-input v-model="form.type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="抽取数量">
              <el-input-number
                v-model="form.num"
                @change="numChange"
                :min="1"
                :max="10"
                :disabled="randomBtn"
                label="抽取专家的数量"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <el-row class="border-1">
      <div class="result-box" v-show="showResult">
        <transition-group name="list-complete" tag="div">
          <span
            ref="peopleList"
            :style="{'--random-start': true}"
            class="list-complete-item"
            v-for="user in userList"
            :key="user.expertId"
          >
            <span class="confirm">✔</span>
            <p>{{ user.name }}</p>
            <p class="card-no">{{ user.cardNo }}</p>
          </span>
        </transition-group>
      </div>
    </el-row>
    <div style="display: none">
      <div id="printArea" class="print-area">
        <h1>评审专家随机抽取记录表</h1>
        <table>
          <tr>
            <td class="td1">项目名称</td>
            <td colspan="3">{{ form.projectname }}</td>
          </tr>
          <tr>
            <td class="td1">项目编号</td>
            <td colspan="3">{{ form.code }}</td>
          </tr>
          <tr>
            <td class="td1">业主单位名称</td>
            <td colspan="3">{{ form.username }}</td>
          </tr>
          <tr>
            <td class="td1">抽取时间</td>
            <td>{{ nowTime }}</td>
            <td class="td1">专家人数</td>
            <td>{{ form.num }}</td>
          </tr>
          <tr>
            <td class="td1">专家姓名</td>
            <td class="td1">专家证号</td>
            <td class="td1">电话号码</td>
            <td class="td1">备注</td>
          </tr>
          <tr v-for="(user,index) in userList" :key="index">
            <td>{{ user.name }}</td>
            <td>{{ user.cardNo }}</td>
            <td>{{ user.phone }}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="4" class="sign">监督签字:</td>
          </tr>
        </table>
      </div>
    </div>
    <el-row class="btn-box">
      <el-button type="success" :disabled="printBtn" :loading="msgloading" @click="sendMsg">短信通知
      </el-button>
      <el-button :disabled="printBtn" v-print="print">打印结果</el-button>
      <el-button type="primary" @click="onSubmit" :disabled="randomBtn">随机抽取</el-button>
    </el-row>

  </div>
</template>

<script>
import { get } from '@/util/Http';
import { dateFormat } from '@/util/common';

export default {
  name: 'Random',
  data() {
    return {
      msgloading: false,
      userList: [{ expertId: 0 }],
      form: {
        time: '',
        projectname: '',
        code: '',
        username: '',
        num: 1,
        type: '',
      },
      showResult: true,
      nowTime: '',
      randomBtn: false,
      printBtn: true,
      print: {
        id: 'printArea',
        popTitle: '', // 打印配置页上方标题
        extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
        preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
        previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
        previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
        zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
        previewBeforeOpenCallback() {
          this.$refs.printWindow.style.display = 'unset';
        }, // 预览窗口打开之前的callback（开启预览模式调用）
        previewOpenCallback() {
        }, // 预览窗口打开之后的callback（开启预览模式调用）
        beforeOpenCallback() {
        }, // 开启打印前的回调事件
        openCallback() {
        }, // 调用打印之后的回调事件
        closeCallback() {
        }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
        url: '',
        standard: '',
        extraCss: '',
      },
    };
  },
  created() {
  },
  methods: {
    sendMsg() {
      this.msgloading = true;
      const nothis = this;
      setTimeout(() => {
        nothis.$confirm('已成功短信通知专家参加评标会', '短信通知', {
          confirmButtonText: '确定',
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'success',
        });
        nothis.msgloading = false;
      }, 4500);
    },
    numChange(currentValue) {
      this.userList = [];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < currentValue; i++) {
        this.userList.push({ expertId: i });
      }
    },
    // eslint-disable-next-line consistent-return
    onSubmit() {
      if (!this.form.projectname || !this.form.code || !this.form.username || !this.form.type) {
        return this.$message.error('请输入基本信息');
      }
      this.randomExpert();
    },
    randomSort(arr) {
      let index;
      let randomIndex;
      let temp;
      const len = arr.length;
      for (index = 0; index < len; index += 1) {
        randomIndex = Math.floor(Math.random() * (len - index)) + index;
        temp = arr[index];
        // eslint-disable-next-line no-param-reassign
        arr[index] = arr[randomIndex];
        // eslint-disable-next-line no-param-reassign
        arr[randomIndex] = temp;
      }
      return arr;
    },
    randomExpert() {
      get('/news/expert/random', {
        num: this.form.num,
        not: true,
      }, { token: this.$store.state.token })
        // eslint-disable-next-line consistent-return
        .then((result) => {
          if (result.status === 200 && result.data.code === 0) {
            if (result.data.list.length !== this.form.num) {
              return this.$message.error('出现内部错误！请联系管理员！');
            }
            this.randomSort(result.data.list);
            this.randomBtn = true;
            this.nowTime = dateFormat('YYYY年mm月dd日', new Date());
            const that = this;
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.form.num; i += 1) {
              setTimeout(() => {
                // 添加动画
                this.$refs.peopleList[i].classList.add('act');
                // 延时删除动画
                setTimeout(() => {
                  const {
                    name,
                    cardNo,
                    phone,
                  } = result.data.list[i];
                  this.$set(this.userList[i], 'name', name);
                  this.$set(this.userList[i], 'cardNo', cardNo);
                  this.$set(this.userList[i], 'phone', phone);
                  this.$refs.peopleList[i].classList.remove('act');
                  this.$refs.peopleList[i].classList.add('done');
                  if (that.form.num === i + 1) {
                    that.printBtn = false;
                  }
                }, 2650);
              }, 2700 * i + 50);
            }
          } else {
            this.$message.error(result.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    },
  },
};
</script>

<style>
.print-area {

}

.content {
  width: 1200px;
  margin: 0 auto;
  max-width: 100%;
}

.form-row {
  margin-bottom: 10px;
}

.border-1 {
  border-bottom: 1px solid #eee;
}

.result-box div {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.card-no {
  font-size: 20px;
  padding: 5px 10px;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: center;
}

.list-complete-item {
  position: relative;
  box-sizing: border-box;
  width: calc(20% - 10px);
  margin: 5px;
  height: 230px;
  border-radius: 10px;
  transition: all 1s;
  display: flex;
  border: 2px solid #eee;
  font-weight: 700;
  font-size: 40px;
  color: #fff;
  background-color: #06b3fc;
  backdrop-filter: blur(20px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.list-complete-item.act {
  font-size: 0;
}

.list-complete-item::before {
  color: #6b6b6b;
  border-radius: 6px;
  box-sizing: border-box;
  content: "?";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, .8);
  background-color: #eee;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  display: flex;
  justify-content: center;
  font-size: 120px;
  border: 2px solid #eee;
  font-family: Helvetica;
  font-weight: 700;
  align-items: center;
}

.list-complete-item.act::before {
  box-shadow: 0 0 30px #898888;
  animation: random 2.7s infinite;
  -webkit-animation: random 2.7s infinite;
}

.list-complete-item.act::after {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  position: absolute;
  box-sizing: border-box;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 4px solid #06b3fc;
  transition: all .5s;
  animation: clippath 0.5s infinite linear;
  z-index: 9;
}

@keyframes clippath {
  0%, 100% {
    clip-path: inset(0 0 95% 0);
  }
  25% {
    clip-path: inset(0 95% 0 0);
  }
  50% {
    clip-path: inset(95% 0 0 0);
  }
  75% {
    clip-path: inset(0 0 0 95%);
  }
}

.list-complete-item.done::before {
  display: none;
}

.random-start {
  animation: random 2.7s infinite;
  -webkit-animation: random 2.7s infinite;
}

.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.result-box .confirm {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #42b983;
  color: #fff;
  font-size: 35px;
  font-weight: 700;
  line-height: 50px;
  box-sizing: border-box;
  text-align: center;
}

.btn-box {
  float: right;
  margin: 10px 0;
}

@keyframes random {
  0% {
    content: "?";
  }
  25% {
    content: ".";
  }
  50% {
    content: "..";
  }
  75% {
    content: "...";
  }
  100% {
    content: "?";
  }
}

.print-area {
  width: 100%;
  text-align: center;
}

.print-area h1 {
  text-align: center;
  width: 100%;
  margin: 10mm 0;
}

.print-area table {
  width: 100%;
  border: 1px solid #000;
  border-collapse: collapse;
  padding: 20px;
  text-align: left;
}

.print-area table td {
  border: 1px solid #000;
  height: 12mm;
  padding: 3mm;
  text-align: center;
}

.print-area table .td1 {
  width: 40mm;
  text-align: center;
  font-weight: 700;
}

.print-area table .sign {
  text-align: left;
  height: 50mm;
  text-indent: 15mm;
  font-weight: 700;
}

.one .el-input {
  width: 501px;
}

.two .el-input {
  width: 480px;
}

.time .el-date-editor{
  width: 200px;
}
</style>
